var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.$store.state.business.hasOwnProperty('tools') &&
      _vm.$store.state.business.tools.miando.status === 'ACTIVE'
    )?_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-start":""}},[_c('v-flex',{staticClass:"mb-7",staticStyle:{"width":"100%"}},[_c('miando-table')],1)],1):_c('v-layout',{attrs:{"justify-center":"","align-center":"","fill-height":""}},[_c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-start":""}},[_c('v-flex',{staticClass:"mt-4 mb-15",staticStyle:{"width":"100%"}},[_c('guide')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }